import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon, Typography } from '@mui/material';
import { ReactComponent as ThreeDRotationIcon } from 'mui/assets/icons/ThreeD.svg';

import ChangeLocationButton from 'components/Booking-new/modules/Steps/shared/ChangeLocationButton';

import FreeParkingHeading from './components/FreeParkingHeading';

import { StyledHeader, StyledLocationDate, StyledSpan, StyledServiceNameWrapper } from './styles';

const StepHeader = ({ title, isFreeParking, locationHeading, serviceName, date, isBackToLocationButton }) => {
  return (
    <StyledHeader>
      <Typography component="h1" variant="DS_copyBigBold" data-test="heading-title">
        {title}
      </Typography>
      {serviceName && (
        <StyledServiceNameWrapper>
          <Typography component="p" variant="DS_copyMediumRegular">
            {serviceName.includes('can') ? (
              <StyledSpan>
                <SvgIcon component={ThreeDRotationIcon} />
              </StyledSpan>
            ) : null}
            {serviceName}
          </Typography>
        </StyledServiceNameWrapper>
      )}

      <StyledLocationDate>
        {locationHeading && (
          <Typography component="p" variant="DS_copyMediumRegular">
            {locationHeading}
          </Typography>
        )}
        {isBackToLocationButton && <ChangeLocationButton />}
        {date && (
          <Typography component="p" variant="DS_copyMediumRegular">
            {date}
          </Typography>
        )}
      </StyledLocationDate>

      {isFreeParking && <FreeParkingHeading />}
    </StyledHeader>
  );
};

StepHeader.defaultProps = {
  isBackToLocationButton: false,
  isFreeParking: null,
};

StepHeader.propTypes = {
  title: PropTypes.string.isRequired,
  isFreeParking: PropTypes.bool,
  locationHeading: PropTypes.string,
  serviceName: PropTypes.string,
  date: PropTypes.string,
  isBackToLocationButton: PropTypes.bool,
};

export default StepHeader;
